import { http } from '../../config/axios'

export default function getRelatorioDownload(id:string) :Promise<Blob>{
    return http.get('/api/relatorio/download/' + id, {
        responseType: 'blob'
    })
    .then((r) => r.data)
    .then((blobFile) => {
        return blobFile
    })
    .catch((error) => {
        console.error('Erro ao baixar download relatório')
        return new Blob()
    })
}